import { Union, Record } from "./fable_modules/fable-library-js.4.17.0/Types.js";
import { obj_type, int32_type, array_type, union_type, string_type, option_type, record_type, bool_type } from "./fable_modules/fable-library-js.4.17.0/Reflection.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.17.0/Result.js";
import { fromString } from "./fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { equals, createObj, comparePrimitives, stringHash, uncurry2 } from "./fable_modules/fable-library-js.4.17.0/Util.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6, toString } from "./fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Post_$reflection } from "./Shared/ApiDataTypes.js";
import { FetchError, FetchError_$reflection } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { mapIndexed, map, sort, tryHead, sortByDescending, append } from "./fable_modules/fable-library-js.4.17.0/Array.js";
import { Time_parseAsUtc } from "./Components/Utils.js";
import { Array_distinctBy } from "./fable_modules/fable-library-js.4.17.0/Seq2.js";
import { compare } from "./fable_modules/fable-library-js.4.17.0/Date.js";
import { append as append_1, empty as empty_1, singleton, delay, toList, fold } from "./fable_modules/fable-library-js.4.17.0/Seq.js";
import { unwrap, map as map_1, defaultArg, toArray } from "./fable_modules/fable-library-js.4.17.0/Option.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { cons, ofArray, empty } from "./fable_modules/fable-library-js.4.17.0/List.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.17.0/MapUtil.js";
import { toString as toString_1 } from "./fable_modules/Thoth.Json.6.0.0/Encode.fs.js";
import { fromString as fromString_1 } from "./fable_modules/Thoth.Json.6.0.0/Decode.fs.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { LoadingIndicator_loadingIndicator, LoadingIndicator_postLoadingIndicator, Alert_snackError, Button_pillButton, Button_cancelButton, Dialog_dialogActions, Checkbox_checkbox, Dialog_dialogContent, Dialog_dialogTitle, Dialog_Dialog } from "./Components/Components.js";
import { Interop_reactApi } from "./fable_modules/Feliz.2.7.0/Interop.fs.js";
import { post } from "./Components/Posts/Post.js";
import { FeedEntry } from "./Components/Ads.js";
import { useFeliz_React__React_useState_Static_1505, useReact_useEffectOnce_3A5B6456, useReact_useReducer_2B9E6EA0 } from "./fable_modules/Feliz.2.7.0/React.fs.js";

export class Filter extends Record {
    constructor(InsiderTrades, Short, Reviews, Posts, Dividends) {
        super();
        this.InsiderTrades = InsiderTrades;
        this.Short = Short;
        this.Reviews = Reviews;
        this.Posts = Posts;
        this.Dividends = Dividends;
    }
}

export function Filter_$reflection() {
    return record_type("Investfora.Feed.Filter", [], Filter, () => [["InsiderTrades", bool_type], ["Short", bool_type], ["Reviews", bool_type], ["Posts", bool_type], ["Dividends", bool_type]]);
}

export function Filter_DefaultMyFeed() {
    return new Filter(true, true, true, true, true);
}

export function Filter_DefaultLatestNews() {
    const bind$0040 = Filter_DefaultMyFeed();
    return new Filter(bind$0040.InsiderTrades, false, bind$0040.Reviews, bind$0040.Posts, bind$0040.Dividends);
}

export function Filter__NumActive(this$) {
    const y = (b) => {
        if (b) {
            return 1;
        }
        else {
            return 0;
        }
    };
    return ((((y(this$.InsiderTrades) + y(this$.Short)) + y(this$.Reviews)) + y(this$.Posts)) + y(this$.Dividends)) | 0;
}

export function Filter__ToHttpVars(this$) {
    return `${`&include_short=${this$.Short}`}${`&include_it=${this$.InsiderTrades}`}${`&include_reviews=${this$.Reviews}`}${`&include_posts=${this$.Posts}`}${`&include_dividends=${this$.Dividends}`}`;
}

export function Filter__AnyActive(this$) {
    if (((this$.InsiderTrades ? true : this$.Short) ? true : this$.Reviews) ? true : this$.Posts) {
        return true;
    }
    else {
        return this$.Dividends;
    }
}

export class FeedPreferences extends Record {
    constructor(MyFeedPref, LatestNewsPref, Section) {
        super();
        this.MyFeedPref = MyFeedPref;
        this.LatestNewsPref = LatestNewsPref;
        this.Section = Section;
    }
}

export function FeedPreferences_$reflection() {
    return record_type("Investfora.Feed.FeedPreferences", [], FeedPreferences, () => [["MyFeedPref", option_type(Filter_$reflection())], ["LatestNewsPref", option_type(Filter_$reflection())], ["Section", option_type(string_type)]]);
}

export class Section extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["MyFeed", "LatestNews"];
    }
}

export function Section_$reflection() {
    return union_type("Investfora.Feed.Section", [], Section, () => [[], []]);
}

export function Section__ToId(this$) {
    if (this$.tag === 1) {
        return "latest-news";
    }
    else {
        return "my-feed";
    }
}

export function Section_FromId_6DFDD678(x) {
    let matchResult;
    if (x != null) {
        if (x === "latest-news") {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new Section(1, []);
        default:
            return new Section(0, []);
    }
}

function filterFromPref(section, x) {
    if (x.tag === 0) {
        const y = x.fields[0];
        if (section.tag === 1) {
            const matchValue_1 = y.LatestNewsPref;
            if (matchValue_1 != null) {
                return matchValue_1;
            }
            else {
                return Filter_DefaultLatestNews();
            }
        }
        else {
            const matchValue = y.MyFeedPref;
            if (matchValue != null) {
                return matchValue;
            }
            else {
                return Filter_DefaultMyFeed();
            }
        }
    }
    else if (section.tag === 1) {
        return Filter_DefaultLatestNews();
    }
    else {
        return Filter_DefaultMyFeed();
    }
}

export function tryGetFeedPreferences() {
    try {
        return fromString(uncurry2(Auto_generateBoxedDecoder_Z6670B51(FeedPreferences_$reflection(), undefined, undefined)), localStorage.getItem("aksjeio-feed-prefs"));
    }
    catch (matchValue) {
        return new FSharpResult$2(1, [""]);
    }
}

export function storeFeedPreference(x) {
    try {
        const x_1 = toString(2, Auto_generateBoxedEncoder_437914C6(FeedPreferences_$reflection(), undefined, undefined, undefined)(x));
        localStorage.setItem("aksjeio-feed-prefs", x_1);
    }
    catch (matchValue) {
    }
}

function saveFilter(section, filter) {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const matchValue = tryGetFeedPreferences();
        if (matchValue.tag === 0) {
            const p = matchValue.fields[0];
            storeFeedPreference((section.tag === 1) ? (new FeedPreferences(p.MyFeedPref, filter, p.Section)) : (new FeedPreferences(filter, p.LatestNewsPref, p.Section)));
            return Promise.resolve();
        }
        else {
            return Promise.resolve();
        }
    }));
    pr.then();
}

export function setPrefSection(section) {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const matchValue = tryGetFeedPreferences();
        if (matchValue.tag === 0) {
            const p = matchValue.fields[0];
            storeFeedPreference(new FeedPreferences(p.MyFeedPref, p.LatestNewsPref, Section__ToId(section)));
            return Promise.resolve();
        }
        else {
            storeFeedPreference(new FeedPreferences(undefined, undefined, Section__ToId(section)));
            return Promise.resolve();
        }
    }));
    pr.then();
}

class Model extends Record {
    constructor(TargetSection, Posts, ErrorMsg, LastReviewId, LastAssetPostId, LastShortEventDate, LastDividendDate, ShortSkips, LastInsiderTradeId, DividendSkips, More, FilterForm, CurrentFilter) {
        super();
        this.TargetSection = TargetSection;
        this.Posts = Posts;
        this.ErrorMsg = ErrorMsg;
        this.LastReviewId = LastReviewId;
        this.LastAssetPostId = LastAssetPostId;
        this.LastShortEventDate = LastShortEventDate;
        this.LastDividendDate = LastDividendDate;
        this.ShortSkips = ShortSkips;
        this.LastInsiderTradeId = LastInsiderTradeId;
        this.DividendSkips = DividendSkips;
        this.More = More;
        this.FilterForm = FilterForm;
        this.CurrentFilter = CurrentFilter;
    }
}

function Model_$reflection() {
    return record_type("Investfora.Feed.Model", [], Model, () => [["TargetSection", Section_$reflection()], ["Posts", option_type(array_type(Post_$reflection()))], ["ErrorMsg", option_type(string_type)], ["LastReviewId", option_type(int32_type)], ["LastAssetPostId", option_type(int32_type)], ["LastShortEventDate", option_type(string_type)], ["LastDividendDate", option_type(string_type)], ["ShortSkips", option_type(int32_type)], ["LastInsiderTradeId", option_type(int32_type)], ["DividendSkips", option_type(int32_type)], ["More", bool_type], ["FilterForm", option_type(Filter_$reflection())], ["CurrentFilter", Filter_$reflection()]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PostsResponse", "AppendPost", "RemovePost", "UpdateFilterForm", "SetFilter", "CommitFilter", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Investfora.Feed.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Post_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Post_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", Post_$reflection()]], [["Item", int32_type]], [["Item", option_type(Filter_$reflection())]], [["Item", Filter_$reflection()]], [["Item", Filter_$reflection()]], []]);
}

function init(section) {
    return new Model(section, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true, undefined, filterFromPref(section, tryGetFeedPreferences()));
}

function update(model, msg) {
    let matchValue_8, matchValue_9, array_28, matchValue, array_16, array_15, lse_1, array_27, array_26;
    switch (msg.tag) {
        case 1: {
            const x_8 = msg.fields[0];
            return new Model(model.TargetSection, (matchValue_8 = model.Posts, (matchValue_8 == null) ? [x_8] : append([x_8], matchValue_8)), model.ErrorMsg, model.LastReviewId, model.LastAssetPostId, model.LastShortEventDate, model.LastDividendDate, model.ShortSkips, model.LastInsiderTradeId, model.DividendSkips, model.More, model.FilterForm, model.CurrentFilter);
        }
        case 2:
            return new Model(model.TargetSection, (matchValue_9 = model.Posts, (matchValue_9 != null) ? ((array_28 = matchValue_9, array_28.filter((a) => (a.Id !== msg.fields[0])))) : undefined), model.ErrorMsg, model.LastReviewId, model.LastAssetPostId, model.LastShortEventDate, model.LastDividendDate, model.ShortSkips, model.LastInsiderTradeId, model.DividendSkips, model.More, model.FilterForm, model.CurrentFilter);
        case 3:
            return new Model(model.TargetSection, model.Posts, model.ErrorMsg, model.LastReviewId, model.LastAssetPostId, model.LastShortEventDate, model.LastDividendDate, model.ShortSkips, model.LastInsiderTradeId, model.DividendSkips, model.More, msg.fields[0], model.CurrentFilter);
        case 4:
            return new Model(model.TargetSection, model.Posts, model.ErrorMsg, model.LastReviewId, model.LastAssetPostId, model.LastShortEventDate, model.LastDividendDate, model.ShortSkips, model.LastInsiderTradeId, model.DividendSkips, model.More, model.FilterForm, msg.fields[0]);
        case 5: {
            const x_12 = msg.fields[0];
            saveFilter(model.TargetSection, x_12);
            return new Model(model.TargetSection, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true, undefined, x_12);
        }
        case 6:
            return new Model(model.TargetSection, model.Posts, undefined, model.LastReviewId, model.LastAssetPostId, model.LastShortEventDate, model.LastDividendDate, model.ShortSkips, model.LastInsiderTradeId, model.DividendSkips, model.More, model.FilterForm, model.CurrentFilter);
        default: {
            const res = msg.fields[0];
            if (res.tag === 0) {
                const x = res.fields[0];
                const p = sortByDescending((z_1) => Time_parseAsUtc(z_1.Published), Array_distinctBy((z) => (`${z.Type}-${z.Id}`), (matchValue = model.Posts, (matchValue != null) ? append(matchValue, x) : x), {
                    Equals: (x_1, y_3) => (x_1 === y_3),
                    GetHashCode: stringHash,
                }), {
                    Compare: compare,
                });
                let lastReviewId;
                const lowest = tryHead(sort(map((y_6) => y_6.Id, p.filter((y_5) => (y_5.Type === "review")), Int32Array), {
                    Compare: comparePrimitives,
                }));
                const matchValue_1 = model.LastReviewId;
                if (matchValue_1 != null) {
                    const l = matchValue_1 | 0;
                    lastReviewId = fold((_arg, z_2) => {
                        if (z_2 < l) {
                            return z_2 | 0;
                        }
                        else {
                            return l | 0;
                        }
                    }, l, toArray(lowest));
                }
                else {
                    lastReviewId = lowest;
                }
                let lastAssetPostId;
                const lowest_1 = tryHead(sort(map((y_9) => y_9.Id, p.filter((y_8) => (y_8.Type === "asset-post")), Int32Array), {
                    Compare: comparePrimitives,
                }));
                const matchValue_2 = model.LastAssetPostId;
                if (matchValue_2 != null) {
                    const l_1 = matchValue_2 | 0;
                    lastAssetPostId = fold((_arg_1, z_3) => {
                        if (z_3 < l_1) {
                            return z_3 | 0;
                        }
                        else {
                            return l_1 | 0;
                        }
                    }, l_1, toArray(lowest_1));
                }
                else {
                    lastAssetPostId = lowest_1;
                }
                let patternInput;
                const lowest_2 = tryHead(sort(map((y_12) => y_12.Published, p.filter((y_11) => (y_11.Type === "short-event"))), {
                    Compare: comparePrimitives,
                }));
                const matchValue_3 = model.LastShortEventDate;
                if (matchValue_3 != null) {
                    const l_2 = matchValue_3;
                    const newLowest = fold((_arg_2, z_4) => {
                        if (z_4 < l_2) {
                            return z_4;
                        }
                        else {
                            return l_2;
                        }
                    }, l_2, toArray(lowest_2));
                    patternInput = [newLowest, newLowest !== l_2];
                }
                else {
                    patternInput = [lowest_2, false];
                }
                const lastShortEventDate = patternInput[0];
                let shortEventSkips;
                if (patternInput[1]) {
                    shortEventSkips = undefined;
                }
                else if (lastShortEventDate != null) {
                    const lse = lastShortEventDate;
                    shortEventSkips = ((array_16 = ((array_15 = p.filter((e) => (e.Type === "short-event")), array_15.filter((e_1) => (e_1.Published === lse)))), array_16.length));
                }
                else {
                    shortEventSkips = undefined;
                }
                let lastInsiderTradeId;
                const lowest_3 = tryHead(sort(map((y_15) => y_15.Id, p.filter((y_14) => (y_14.Type === "insider-trade")), Int32Array), {
                    Compare: comparePrimitives,
                }));
                const matchValue_4 = model.LastInsiderTradeId;
                if (matchValue_4 != null) {
                    const l_3 = matchValue_4 | 0;
                    lastInsiderTradeId = fold((_arg_3, z_5) => {
                        if (z_5 < l_3) {
                            return z_5 | 0;
                        }
                        else {
                            return l_3 | 0;
                        }
                    }, l_3, toArray(lowest_3));
                }
                else {
                    lastInsiderTradeId = lowest_3;
                }
                let patternInput_1;
                const lowest_4 = tryHead(sort(map((y_18) => {
                    const matchValue_5 = y_18.DividendInfo;
                    if (matchValue_5 == null) {
                        return y_18.Published;
                    }
                    else {
                        return matchValue_5.AnnouncementDate;
                    }
                }, p.filter((y_17) => (y_17.Type === "dividend"))), {
                    Compare: comparePrimitives,
                }));
                const matchValue_6 = model.LastDividendDate;
                if (matchValue_6 != null) {
                    const l_4 = matchValue_6;
                    const newLowest_1 = fold((_arg_4, z_6) => {
                        if (z_6 < l_4) {
                            return z_6;
                        }
                        else {
                            return l_4;
                        }
                    }, l_4, toArray(lowest_4));
                    patternInput_1 = [newLowest_1, newLowest_1 !== l_4];
                }
                else {
                    patternInput_1 = [lowest_4, false];
                }
                const lastDividendDate = patternInput_1[0];
                return new Model(model.TargetSection, p, model.ErrorMsg, lastReviewId, lastAssetPostId, lastShortEventDate, lastDividendDate, shortEventSkips, lastInsiderTradeId, patternInput_1[1] ? undefined : ((lastDividendDate != null) ? ((lse_1 = lastDividendDate, (array_27 = ((array_26 = p.filter((e_2) => (e_2.Type === "dividend")), array_26.filter((e_3) => {
                    const matchValue_7 = e_3.DividendInfo;
                    if (matchValue_7 == null) {
                        return e_3.Published === lse_1;
                    }
                    else {
                        return matchValue_7.AnnouncementDate === lse_1;
                    }
                }))), array_27.length))) : undefined), x.length > 0, model.FilterForm, model.CurrentFilter);
            }
            else {
                const err = res.fields[0];
                return new Model(model.TargetSection, model.Posts, (err.tag === 2) ? (((err.fields[0].status) === 401) ? "Kunne ikke laste feed, ikke innlogget. Vennligst logg inn på nytt." : "Kunne ikke laste feed. Vennligst prøv igjen senere.") : "Kunne ikke laste feed. Vennligst prøv igjen senere.", model.LastReviewId, model.LastAssetPostId, model.LastShortEventDate, model.LastDividendDate, model.ShortSkips, model.LastInsiderTradeId, model.DividendSkips, model.More, model.FilterForm, model.CurrentFilter);
            }
        }
    }
}

function fetchFeed(section, revId, apId, seDt, seSkip, itId, dvdDt, dvdSkip, filter, dispatch) {
    const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let decoder, data_1, caseStrategy_2, extra_2;
        let requestPath;
        const r = fold((_arg, x) => (`&rid=${x}`), "", toArray(revId));
        const a = fold((_arg_1, x_1) => (`&pid=${x_1}`), "", toArray(apId));
        const seDt$0027 = fold((_arg_2, x_2) => (`&sedt=${x_2}`), "", toArray(seDt));
        const se = fold((_arg_3, x_3) => (`&se_skip=${x_3}`), "", toArray(seSkip));
        const insider = fold((_arg_4, x_4) => (`&itid=${x_4}`), "", toArray(itId));
        const dvdDt$0027 = fold((_arg_5, x_5) => (`&dvddt=${x_5}`), "", toArray(dvdDt));
        const dvdSkip$0027 = fold((_arg_6, x_6) => (`&dvd_skip=${x_6}`), "", toArray(dvdSkip));
        const excludeFilters = Filter__ToHttpVars(filter);
        const q = ((((((((revId != null) ? true : (apId != null)) ? true : (seDt != null)) ? true : (seSkip != null)) ? true : (itId != null)) ? true : (dvdDt != null)) ? true : (dvdSkip != null)) ? true : (excludeFilters.length > 0)) ? "?" : "";
        requestPath = (`${(section.tag === 1) ? "/api/feed/latest-news" : "/api/feed"}${q}${r}${a}${seDt$0027}${se}${insider}${dvdDt$0027}${dvdSkip$0027}${excludeFilters}`);
        return ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Post_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(empty(), (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map_1((data_1_1) => cons(new Types_RequestProperties(2, [toString_1(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, caseStrategy_2, extra_2)(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(requestPath, properties_3).then((_arg_7) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg_7, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Post_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_8) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString_1(uncurry2(decoder_1_1), _arg_8), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))).then((_arg_9) => {
            dispatch(new Message(0, [_arg_9]));
            return Promise.resolve();
        });
    }));
    pr_1.then();
}

function refresh(section, filter, dispatch) {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        fetchFeed(section, undefined, undefined, undefined, undefined, undefined, undefined, undefined, filter, dispatch);
        return Promise.resolve();
    }));
    pr.then();
}

function filterModal(model, dispatch, filter) {
    let elems;
    const feedName = (model.TargetSection.tag === 1) ? "\"Siste nytt\"" : "\"Min feed\"";
    const anyActive = Filter__AnyActive(filter);
    return createElement(Dialog_Dialog, {
        onClose: () => {
            dispatch(new Message(3, [undefined]));
        },
        children: ofArray([Dialog_dialogTitle(`Filter for ${feedName}`), Dialog_dialogContent(ofArray([createElement("span", {
            children: ["Velg hvilket innhold som skal vises i feeden."],
        }), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 10 + "px ",
        }], (elems = [Checkbox_checkbox("Innsidehandler", filter.InsiderTrades, (b) => {
            dispatch(new Message(3, [new Filter(b, filter.Short, filter.Reviews, filter.Posts, filter.Dividends)]));
        }), Checkbox_checkbox("Short-oppdateringer", filter.Short, (b_1) => {
            dispatch(new Message(3, [new Filter(filter.InsiderTrades, b_1, filter.Reviews, filter.Posts, filter.Dividends)]));
        }), Checkbox_checkbox("Utbytteannonseringer", filter.Dividends, (b_2) => {
            dispatch(new Message(3, [new Filter(filter.InsiderTrades, filter.Short, filter.Reviews, filter.Posts, b_2)]));
        }), Checkbox_checkbox("Analyser", filter.Reviews, (b_3) => {
            dispatch(new Message(3, [new Filter(filter.InsiderTrades, filter.Short, b_3, filter.Posts, filter.Dividends)]));
        }), Checkbox_checkbox("Innlegg", filter.Posts, (b_4) => {
            dispatch(new Message(3, [new Filter(filter.InsiderTrades, filter.Short, filter.Reviews, b_4, filter.Dividends)]));
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))])), Dialog_dialogActions(ofArray([Button_cancelButton("Forkast", (_arg_1) => {
            dispatch(new Message(3, [undefined]));
        }, empty()), Button_pillButton("Bruk", (_arg_2) => {
            if (anyActive) {
                dispatch(new Message(5, [filter]));
                fetchFeed(model.TargetSection, undefined, undefined, undefined, undefined, undefined, undefined, undefined, filter, dispatch);
            }
        }, toList(delay(() => (!anyActive ? singleton(["opacity", 0.3]) : empty_1()))))]))]),
    });
}

function feedFilterBanner(model, dispatch, triggerSection) {
    let elems_3, elems_1, elems_2;
    const sectionButton = (section, title) => {
        let elems;
        return createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton(["userSelect", "none"]), delay(() => append_1(singleton(["cursor", "pointer"]), delay(() => append_1(equals(model.TargetSection, section) ? singleton(["color", "var(--text-main)"]) : singleton(["color", "var(--text-dim)"]), delay(() => singleton(["borderBottom", (((2 + "px ") + "solid") + " ") + (equals(model.TargetSection, section) ? "var(--text-main)" : "#fff")]))))))))))], ["onClick", (_arg) => {
            triggerSection(section);
        }], (elems = [createElement("span", {
            children: [title],
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
    };
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "baseline",
        alignItems: "center",
        gap: 10 + "px ",
        width: 100 + "%",
        flexDirection: "row",
        justifyContent: "space-between",
        backgroundColor: "#FFFFFF",
        border: (((1 + "px ") + "solid") + " ") + "#e1e1e1",
        borderRadius: 5,
    }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 20 + "px ",
        margin: 10,
        fontWeight: "bold",
        fontSize: 1 + "rem",
    }], (elems_1 = [sectionButton(new Section(0, []), "Min feed"), sectionButton(new Section(1, []), "Siste nytt")], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 10 + "px ",
        fontSize: 1 + "rem",
        cursor: "pointer",
        userSelect: "none",
        margin: 10,
        fontWeight: "bold",
    }], ["onClick", (_arg_1) => {
        dispatch(new Message(3, [model.CurrentFilter]));
    }], (elems_2 = [createElement("i", {
        className: "fas fa-sliders-h",
    }), createElement("span", {
        children: [`Filter (${Filter__NumActive(model.CurrentFilter)}/5)`],
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])));
}

function view(model, dispatch, triggerSection) {
    let elems_2;
    return createElement("div", createObj(ofArray([["className", "feed"], ["style", {
        height: 100 + "%",
        marginBottom: 5 + "vh",
    }], (elems_2 = toList(delay(() => append_1(singleton(Alert_snackError(model.ErrorMsg, () => {
        dispatch(new Message(6, []));
    })), delay(() => append_1(singleton(feedFilterBanner(model, dispatch, triggerSection)), delay(() => {
        let matchValue;
        return append_1((matchValue = model.FilterForm, (matchValue != null) ? singleton(filterModal(model, dispatch, matchValue)) : (empty_1())), delay(() => {
            let elems, xs_3;
            const matchValue_1 = model.Posts;
            if (matchValue_1 != null) {
                const x = matchValue_1;
                return (x.length === 0) ? singleton(createElement("div", createObj(ofArray([["style", {
                    height: 100 + "%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                }], (elems = [createElement("span", {
                    style: {
                        fontSize: 2 + "rem",
                        fontWeight: "bold",
                        margin: ((20 + "px ") + 0) + "px",
                    },
                    children: "Her var det tomt",
                }), createElement("p", {
                    children: [(model.TargetSection.tag === 1) ? "Kontroller dine feed filter. Trykk på filter-knappen over for å velge hva som skal vises." : "Innsidehandler, analyser og innlegg fra dine favorittaksjer dukker opp her."],
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])))) : append_1(singleton((xs_3 = mapIndexed((i, y) => {
                    const xs_2 = toList(delay(() => append_1(singleton(post(y, (arg) => {
                        dispatch(new Message(2, [arg]));
                    })), delay(() => ((((i + 1) % 4) === 0) ? singleton(createElement(FeedEntry, null)) : empty_1())))));
                    return react.createElement(react.Fragment, {}, ...xs_2);
                }, x), react.createElement(react.Fragment, {}, ...xs_3))), delay(() => {
                    let elems_1;
                    return model.More ? singleton(createElement("div", createObj(ofArray([["style", {
                        textAlign: "center",
                        margin: ((10 + "px ") + 0) + "px",
                    }], (elems_1 = [Button_pillButton("Last mer", (_arg_1) => {
                        fetchFeed(model.TargetSection, model.LastReviewId, model.LastAssetPostId, model.LastShortEventDate, model.ShortSkips, model.LastInsiderTradeId, model.LastDividendDate, model.DividendSkips, model.CurrentFilter, dispatch);
                    }, empty())], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))) : empty_1();
                }));
            }
            else {
                return append_1(singleton(LoadingIndicator_postLoadingIndicator()), delay(() => append_1(singleton(LoadingIndicator_postLoadingIndicator()), delay(() => singleton(LoadingIndicator_postLoadingIndicator())))));
            }
        }));
    })))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function FeedSection(feedSectionInputProps) {
    const onSetSection = feedSectionInputProps.onSetSection;
    const section = feedSectionInputProps.section;
    const patternInput = useReact_useReducer_2B9E6EA0(update, init(section));
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    useReact_useEffectOnce_3A5B6456(() => {
        refresh(section, model_1.CurrentFilter, dispatch);
    });
    return view(model_1, dispatch, onSetSection);
}

export function Feed() {
    let elems;
    const patternInput = useFeliz_React__React_useState_Static_1505(undefined);
    const setFeedSection = patternInput[1];
    const feedSection = patternInput[0];
    useReact_useEffectOnce_3A5B6456(() => {
        const matchValue = tryGetFeedPreferences();
        if (matchValue.tag === 0) {
            setFeedSection(Section_FromId_6DFDD678(matchValue.fields[0].Section));
        }
        else {
            setFeedSection(new Section(0, []));
        }
    });
    return createElement("div", createObj(ofArray([["className", "feed"], ["style", {
        maxWidth: 1200,
    }], (elems = toList(delay(() => {
        if (feedSection != null) {
            const fs = feedSection;
            return singleton(createElement("div", {
                style: {
                    alignItems: "center",
                    gap: 20 + "px ",
                    width: 100 + "%",
                },
                key: `home-feed-${Section__ToId(fs)}`,
                children: createElement(FeedSection, {
                    section: fs,
                    onSetSection: (x) => {
                        if (!equals(x, fs)) {
                            setPrefSection(x);
                            setFeedSection(x);
                        }
                    },
                }),
            }));
        }
        else {
            return singleton(LoadingIndicator_loadingIndicator());
        }
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

